class AcceptanceRulesClassification {
    options = [
        {value: 'AVERIGUACAO_CLONE', label: 'Averiguação de clone'},
        {value: 'FURTADO', label: 'Furtado'},
        {value: 'OUTRO', label: 'Outro'},
        {value: 'PRODUTO', label: 'Produto'},
        {value: 'ROUBADO', label: 'Roubado'},
        {value: 'SUSPEITO', label: 'Suspeito'},
        {value: 'SUSPEICAO_FRACA', label: 'Suspeição fraca'},
    ]

    toOption(json) {
        let values = JSON.parse(json);
        if (!Array.isArray(values)) values = [values]

        return values.map(v => this.options.find(o => o.value === v))
    }
}

const acceptanceRulesClassification = new AcceptanceRulesClassification();

export default acceptanceRulesClassification;